import { UserIcon } from "@heroicons/react/24/solid";

export default function DetailsIcon() {
  return (
    <span className="inline-block h-8 w-8 overflow-hidden rounded-full bg-martEye-100 p-1.5">
      <UserIcon className="h-5 w-5 text-martEye-400" />
    </span>
  );
}
